import {TariffBooleanLimit} from 'entities/tariff';

import IUserOutput from '../model/IUser';

export const isUnderLimit = (limit: number | null | undefined, count: number | null | undefined): boolean => {
    if (limit === undefined || limit === null || count === undefined || count === null) {
        return true;
    }

    return limit > count;
};

export const hasTariffFlag = (user: IUserOutput | null | undefined, flag: TariffBooleanLimit): boolean => {
    return !!user?.tariff?.[flag];
};
